import { adaptadorMock } from '@/auth/adaptadores/mock'
import type { AdaptadorDeAuth } from '@/auth/adaptadores/tipos'
import type { ModoDeAuth } from '@/auth/session'

/**
 * Which implementation backs `useSession()` — the ONE place the swap happens (AC-8).
 *
 * `VITE_AUTH_MODE` is a build-time flag on purpose, and it is the ONLY one: AC-7 asks
 * for the mock to be switchable by environment flag, while the pool id and the API
 * URLs stay in `config.json` so the artifact remains promotable (§4.1). A flag that
 * selects an implementation is a different thing from a value that differs per
 * environment.
 */
export function modoDeAuth(): ModoDeAuth {
  const declarado = import.meta.env.VITE_AUTH_MODE
  if (declarado === 'mock' || declarado === 'cognito') return declarado
  // Nobody has provisioned a pool for a developer's machine; nobody should ship a
  // bypassable login. The defaults follow from that, in both directions.
  return import.meta.env.DEV ? 'mock' : 'cognito'
}

/**
 * Cognito is loaded dynamically so `aws-amplify` lands in its own chunk instead of
 * the entry bundle — a mock-mode build never downloads it, and a real build defers
 * ~90 kB (gzip) of it past first paint. The cost is that adapter selection is async,
 * which `SessionProvider` already is because the boot restore is.
 */
export async function escolherAdaptador(modo: ModoDeAuth = modoDeAuth()): Promise<AdaptadorDeAuth> {
  if (modo === 'mock') return adaptadorMock
  const { adaptadorCognito } = await import('@/auth/adaptadores/cognito')
  return adaptadorCognito
}
